import axios from 'axios'
import { Setting } from "../models/setting.model";
import { BaseService } from "./base.service";

class SettingService extends BaseService {

    constructor() {
        super();
        console.log("created a instance of SettingService");
    }

    async delete(id: number){
        let result = await axios.delete(`${this.api}setting/${id}`);
        return result;
        // return this.execute('delete', `Setting/${id}`);
    }

    async getAll(){
        return axios.get(`${this.api}setting/`).then(req => { return req.data });
        // return this.execute('get', 'Setting/');
    }

    async get(id: number){
        return axios.get(`${this.api}setting/${id}`).then(req => { return req.data });
        // return this.execute('get', `Setting/${id}`);
    }

    async getByCompanyId(companyId: string) {
        return axios.get(`${this.api}setting/GetSettingOnCompany?companyId=${companyId}`).then(req => { return req.data; });
        // return this.execute('get', `Setting/${id}`);
    }

    async create(Setting: Setting){
        let result = await axios.post(`${this.api}setting/`, Setting);
        return result;
    }

    async update(Setting: Setting){
        let result = await axios.put(`${this.api}setting/UpdateSetting`, Setting);
        return result;
    }
}

export const settingService = new SettingService();

